import React, { Component } from 'react';
import { Card, ModalNext, withModalContext } from "@jutro/components";
import { MetadataContent } from "@jutro/uiconfig";
import metadata from './PolicyCoveragePopUp.metadata.json5';
import styles from './PolicyCoveragePopUp.module.scss';


class PolicyCoveragePopUp extends Component {
    state = {
    };

    handleDismiss = (evt) => {
        // eslint-disable-next-line react/prop-types
        const { onResolve } = this.props;
        evt.stopPropagation();
        onResolve();
    }


    render() {
        // eslint-disable-next-line react/prop-types
        const { propsData } = this.props;
        const overrides = {

            cancel: {
                content: 'Got It',
                visible: 'true',
            },
            uninsuredCTContainer: {
                visible: propsData === 'PABasicGA'
            },
            uninsuredCTMSContainer: {
                visible: propsData === 'PABasicMS'
            },
            uninsuredContainer: {
                visible: propsData === 'PABasic'
            },
            uninsuredBIContainer: {
                visible: propsData === 'PABasicGA' || propsData === 'PABasicMS'
            }
        };
        const resolvers = {
            resolveCallbackMap: {
                onCancel: this.handleDismiss,

            },
            resolveClassNameMap: styles,

        };

        return (
            <ModalNext isOpen={this.props.isOpen}>
                <ModalBody>
                    <Card id="standardizedPanel" className={styles.policyCoverageStyle}>
                        <MetadataContent
                            uiProps={metadata.componentContent}
                            overrideProps={overrides}
                            {...resolvers}
                        />
                    </Card>
                </ModalBody>
            </ModalNext>
        );
    }
}

export default withModalContext(PolicyCoveragePopUp);
